export default "__VITE_ASSET__BhvWzffy__"